import React from 'react';
import { observer } from 'mobx-react-lite';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { useAppStateContext } from 'src/AppState/AppState';
import DatePicker from 'react-datepicker';
import { ErrorMessageBar, InputError, InputLabel } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { FormComponent, FormWrapper, DatesWrapper, DateInputWrapper } from 'src/domains/layouts/shared/cms/form/Form.style';
import { CheckboxTitle, CsvInfoWrapper, Note } from './PromoCodesForm.style';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { PromoCodeFormState } from './PromoCodeForm.state';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { Uploader } from 'src/components/Uploader/Uploader';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FormButtons } from 'src/domains/layouts/shared/buttons/FormButtons';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';

export const PromoCodeForm = observer(() => {
    const { promoCodesState, configState } = useAppStateContext();
    const [state] = React.useState(() => new PromoCodeFormState(promoCodesState));
    const { preventDefault, onChangeStartDate, onBlurStartDate, onChangeEndDate, onBlurEndDate, startDateError, endDateError } = state;
    const {
        isLoading,
        errorMessage,
        duplicateError,
        dateError,
        limitError,
        isFormValid,
        isEditMode,
        handleSubmit,
        handleCancel,
        resetForm,
        startDate, endDate,
        numberOfUsesModel,
        number_of_uses,
        numberOfUsesStatus,
        promoCodeModel,
        promo_code,
        promoCodeStatus,
        file,
        fileModel,
        allowedMimeTypes,
        allowedFileTypes,
        csvFile,
        promoFileName,
        isUnlimited,
        addedPromoCodes,
        handleSelectFile,
        handleReplaceFile,
        handleRemoveFile,
        affiliateIdModel,
        affiliate_id,
        affiliateIdStatus,

    } = promoCodesState;

    return (
        <FormWrapper>
            <FormHeader isEditMode={isEditMode} defaultLabel='Create new promo code' editModeLabel='Edit promo code' resetForm={resetForm}/>

            <FormComponent onSubmit={preventDefault}>
                <Loader isActive={isLoading} />

                {!!errorMessage && <ErrorMessageBar>{errorMessage}</ErrorMessageBar>}
                {limitError === null ? null : <ErrorMessageBar>{limitError}</ErrorMessageBar>}
                {duplicateError === null ? null : <ErrorMessageBar>{duplicateError}</ErrorMessageBar>}
                {dateError === null ? null : <ErrorMessageBar>{dateError}</ErrorMessageBar>}

                <OldInput
                    label='Promo Code (Max 30 chracters)'
                    status={promoCodeStatus}
                    formInputState={promo_code}
                    model={promoCodeModel}
                />
                {isEditMode === false ?
                    <>
                        <Label>Upload CSV for promo codes</Label>
                        <Uploader
                            state={file}
                            model={fileModel}
                            hideMaxSizeInfo={true}
                            allowedMimeTypes={allowedMimeTypes}
                            allowedFileTypes={allowedFileTypes}
                            file={csvFile}
                            onSelectFile={handleSelectFile}
                            onReplace={handleReplaceFile}
                            onRemove={handleRemoveFile}
                            uploadingFileName={promoFileName}
                        />

                        <CsvInfoWrapper>
                            <Label>Total promo codes added: {addedPromoCodes === null ? '0' : addedPromoCodes.length}</Label>
                            <Note>Note: Any promo codes uploaded via CSV will all share the same settings you create below.</Note>
                        </CsvInfoWrapper>
                    </> :
                    null}

                <DatesWrapper>
                    <DateInputWrapper>
                        <InputLabel>Start date *</InputLabel>
                        <DatePicker
                            selected={startDate}
                            onChange={onChangeStartDate}
                            onBlur={onBlurStartDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                        />
                        {startDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                    <DateInputWrapper>
                        <InputLabel>End date *</InputLabel>
                        <DatePicker
                            selected={endDate}
                            onChange={onChangeEndDate}
                            onBlur={onBlurEndDate}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            timeCaption='time'
                            dateFormat='MMMM d, yyyy h:mm aa'
                        />
                        {endDateError ? <InputError>This field is required.</InputError> : null}
                    </DateInputWrapper>
                </DatesWrapper>

                <OldInput
                    label='Number of uses (Number of accounts that are able to sign up using this promo code)'
                    status={numberOfUsesStatus}
                    formInputState={number_of_uses}
                    model={numberOfUsesModel}
                />
                {configState.config.affiliateIdPromoCode === true ?
                    <OldInput
                        label='Affiliate ID / Btag (optional)'
                        status={affiliateIdStatus}
                        formInputState={affiliate_id}
                        model={affiliateIdModel}
                    /> : null}

                <Checkbox labelSide='right' onChange={state.onChangeUnlimited} isChecked={isUnlimited} isDisabled={false}>
                    <CheckboxTitle>Allow Unlimited Uses</CheckboxTitle>
                </Checkbox>

                <FormButtons
                    onCreate={handleSubmit}
                    onUpdate={handleSubmit}
                    onCancel={handleCancel}
                    isEditMode={isEditMode}
                    isCreateDisabled={!isFormValid}
                    isUpdateDisabled={!isFormValid}
                />
            </FormComponent>
        </FormWrapper>
    );
});

